<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1350px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="90px">
        <el-form-item label="域名类型:" prop="type">
          <el-select
            v-model="params.type"
            :disabled="type === 'edit'"
            size="small"
          >
            <el-option
              v-for="(item, i) in typeList"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item label="激活状态:" prop="isActive">
          <el-switch v-model="params.isActive" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="域名:" prop="domain" inline-message>
          <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
            <div v-if="!isPreSaleConfig" class="xiangqin_left">
              url:
              <el-input size="small" v-model="item.url"></el-input>
            </div>
            <div v-else class="xiangqin xiangqin_left">
              <span style="margin-right: 15px;">
                <label>封面:</label>
                <base-upload :cover="item.url" :action="action" @successCallback="item.url = $event.data.coverImg"
                  :width="'120px'" :height="'120px'">
                  <template #desc>
                    <span style="text-wrap: nowrap;">图片大小最好不要超过1M</span>
                  </template>
                </base-upload>
              </span>
              <span>
                <label>类型:</label>
                <el-select size="small" v-model="item.type">
                  <el-option v-for="(type, j) in domainTypes" :key="j" :value="type.value"
                    :label="type.label"></el-option>
                </el-select>
              </span>
              <span>
                <label>状态:</label>
                <el-select size="small" v-model="item.status">
                  <el-option v-for="(type, j) in domainStatusTypes" :key="j" :value="type.value"
                    :label="type.label"></el-option>
                </el-select>
              </span>
              <span>
                <label>跳转类型:</label>
                <el-select size="small" v-model="item.jumpType">
                  <el-option v-for="(type, j) in linkTypes" :key="j" :value="type.value"
                    :label="type.label"></el-option>
                </el-select>
              </span>
              <span>
                <label>跳转链接:</label>
                <el-select v-if="item.jumpType == 1" size="small" v-model="item.jumpUrl">
                  <el-option v-for="(type, i) in domainInnerLinks" :key="i" :value="type.value"
                    :label="type.label"></el-option>
                </el-select>
                <el-input v-else v-model="item.jumpUrl" size="small" clearable placeholder="请输入链接地址"></el-input>
              </span>
            </div>
            <div class="xiangqin_left">
              权重:
              <el-input size="small" v-model.number="item.weight"></el-input>
            </div>
            <div class="xiangqin_left">
              备注:
              <el-input size="small" v-model="item.description"></el-input>
            </div>
            <div class="xiangqin_right">
              <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteItem(i)"></el-button>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="域名:" prop="domain">
          <div class="xiangqin" v-for="(item, i) in params.domain" :key="i">
            <div class="xiangqin_left">
              url:
              <el-input style="width:250px" size="small" v-model="item.url"></el-input>
            </div>
            <div class="xiangqin_left">
              权重:
              <el-input size="small" v-model.number="item.weight"></el-input>
            </div>
            <div class="xiangqin_left">
              备注:
              <el-input size="small" v-model.number="item.desc"></el-input>
            </div>
            <div class="xiangqin_right">
              <el-button
                type="primary"
                icon="el-icon-delete"
                size="small"
                @click="deleteItem(i)"
              ></el-button>
            </div>
          </div>
        </el-form-item> -->
        <el-form-item label="域名操作:">
          <el-button
            type="primary"
            size="small"
            @click="addDomain({ url: '', weight: '', desc:'' })"
            >新增域名</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      isAdd: false,
      isClickAdd: false,
      isClickDelete: false,
      width: "600px",
      title: "",
      flag: false,
      id: "",
      type: "",
      params: {
        domain: [],
        type: "",
        isActive: false,
      },
      typeList: [
        { label: "APP服务域名", value: "API" },
        { label: "视频，图片公用(CDN)", value: "COMMON" },
        { label: "视频专用域名(CDN)", value: "VID" },
        { label: "音频专用域名(CDN)", value: "AUDIO" },
        { label: "图片专用域名(CDN)", value: "IMAGE" },
        { label: "potato群号", value: "GROUP" },
        { label: "telegram群号", value: "TELEGRAM" },
        { label: "落地页域名", value: "LAND" },
        { label: "IOS导航域名", value: "GUIDE" },
        { label: "客服中心", value: "CUST" },
        { label: "代理规则", value: "PROXYRULE" },
        { label: "问题常见", value: "FAQ" },
        { label: "二维码链接", value: "QRCODE" },
        { label: "福利入口", value: "WELFARE" },
        { label: " 活动入口", value: "ACT" },
        { label: " 应用商店地址", value: "AppStore" },
        { label: "up主投稿链接", value: "UP" },
        { label: "官方邮箱", value: "Mailbox" },
        { label: "预售活动页背景图", value: "preSaleBgImg" },
        { label: "分享页域名", value: "SHARE" },
        { label: "预售卡配置", value: "preSaleConfig" },
      ],
      domainTypes: [
        { label: '背景图', value: 1 },
        { label: '浮窗', value: 2 },
        { label: '预售弹窗', value: 3 },
        // { label: 'Banner图', value: 4 },
        { label: '个人中心banner', value: 5 },
        { label: '支付按钮', value: 6 },
        { label: '金币视频区背景', value: 7 },
      ],
      domainStatusTypes: [
        { label: '预定', value: 1 },
        { label: '尾款', value: 2 },
        { label: '未到尾款支付', value: 3 },
      ],
      linkTypes: [
        { label: '内链', value: 1 },
        { label: '外链', value: 2 },
      ],
      domainInnerLinks: [
        { label: '会员中心', value: 'yinseinner://vip_page' },
        { label: '金币商城', value: 'yinseinner://wallet_page' },
        { label: '活动详情页', value: 'yinseinner://Activity_page' },
        { label: '预售卡详情页', value: 'yinseinner://Activity_page' },
      ],
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      rules: {
        domain: [
          { required: true, message: "请添加域名", trigger: "blur" },
          { validator: this.validatorAttr, trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择域名类型", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    isPreSaleConfig() {
      return this.params.type === 'preSaleConfig'
    },
    dialogWidth() {
      return this.isPreSaleConfig ? '1350px' : '850px'
    }
  },
  methods: {
    // 校验domain的数据是否正确
    validatorAttr(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error("请添加域名"));
      } else {
        for (let i = 0; i < value.length; i++) {
          if (!value[i].url) {
            callback(new Error("请填写所有的url项"));
          }
          if (value[i].weight === "") {
            callback(new Error("请填写所有的权重项"));
          }
        }
        callback();
      }
    },
    // 删除某项
    deleteItem(i) {
      this.params.domain.splice(i, 1);
    },
    // 新增域名
    addDomain(obj) {
      this.params.domain.push(obj);
    },
    // 提交修改
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增资源") {
            this.addResource();
          } else {
            this.editResource();
          }
        } else {
          return false;
        }
      });
    },
    editResource() {
      let params = Object.assign({}, this.params, { id: this.id });
      API.editSource(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改资源成功",
              type: "success",
            });
            this.$emit("handlerResourceList");
          } else {
            this.$message.error("修改资源失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 添加资源
    addResource() {
      let params = Object.assign({}, this.params);
      API.addSource(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增资源成功",
              type: "success",
            });
            this.$emit("handlerResourceList");
          } else {
            this.$message.error("新增资源失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.isAdd = false;
      this.num = 0;
      this.params = {
        domain: [],
        type: "",
        isActive: false,
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑资源";
        this.params.domain = [...data.domain];
        this.params.type = data.type;
        this.params.isActive = data.isActive;
        this.id = data.id;
      } else {
        (this.title = "新增资源"), (this.isAdd = true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.add-pay-box {
  .el-input {
    width: 150px !important;
    margin-right: 15px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .xiangqin {
    // width: 300px;
    // padding-left: 180px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    /deep/ .avatar {
      object-fit: contain;
    }
    .xiangqin_left {
      margin-right: 15px;
    }
    .el-form-item {
      margin-left: 0px;
    }
    /deep/ .el-input {
      width: 150px !important;
      margin-right: 15px;
    }
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
